import { IMediaList } from './../models';

interface ISplitSwimlanesArgs {
  swimlanes: IMediaList[];
  after?: number;
}

// divides swimlanes array in 2 parts to allow insertion of banner ad on main pages
export const splitSwimlanes = ({ swimlanes, after }: ISplitSwimlanesArgs) => {

  const half = after || Math.ceil(swimlanes.length / 2);
  const swimlanesClone = [...swimlanes];

  return {
    firstSwimlaneHalf: swimlanesClone.splice(0, half),
    secondSwimlaneHalf: swimlanesClone.splice(half),
  };
};
